'use strict';

module.exports = {
  avif: require('./parse_stream/avif'),
  bmp:  require('./parse_stream/bmp'),
  gif:  require('./parse_stream/gif'),
  ico:  require('./parse_stream/ico'),
  jpeg: require('./parse_stream/jpeg'),
  png:  require('./parse_stream/png'),
  psd:  require('./parse_stream/psd'),
  svg:  require('./parse_stream/svg'),
  tiff: require('./parse_stream/tiff'),
  webp: require('./parse_stream/webp')
};
